// declare var google: any;
import { Component, NgZone, OnInit } from '@angular/core';
// import { Events } from '@ionic/angular';
import { Router } from '@angular/router';
import { IRegister } from 'src/app/interfaces/register.interface';
import { HelperProvider } from 'src/app/providers/helper.provider';
import { environment } from 'src/environments/environment';
import { TranslationLoaderService } from '../../core/translation-loader.service';
import { AlertController, Platform, ToastController } from '@ionic/angular';
import { GoogleMap, LatLng, Marker, CapacitorGoogleMaps  } from '@capacitor-community/google-maps';
import { MapMarker } from '@angular/google-maps';
import { Location } from '@angular/common';

import { locale as english } from '../../i18n/en';
import { locale as polish } from '../../i18n/pl';
import { AuthProvider } from 'src/app/providers/auth.provider';

const ROUTE_ID = '6538e66c11e7ac002601ad8b';
const COMPANY_ID = '653a4dd4fa2fae002cbb9ccd';
const CAR_LIST_ID = '6538e61111e7ac002601ad87';
const ORDER_ID = '64fb110f88863301c2d54e34';
const CONTRACT_ID = '653bad415954af00253d1283';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  center = {lat: 40.730610, lng: -73.935242};
  zoom = 13;
  markerOptions = {draggable: false};
  markerPositions: google.maps.LatLngLiteral[] = [];

  isToastOpen = false;
  toastMessage = '';
  dashboardHTML = '';
  otherProblem = '';
  extraProblem = false;
  items = [];
  officeName: string;
  tiles = [];
  regList: any;
  workspaceList: any = [];
  defaultOffice = '64faefc488863301c2d53f93';
  companyList: any;
  mobileState: any;
  view = 'loading';
  carList: any;
  routeList: any;
  routeData: any;
  currentView = 'pickup';
  orderList: any;
  isModalOpen = false;
  currentModalView = 'general';
  selectedOrder: any;
  formData: any = {};
  isBrowser: boolean;
  error: any;
  geoCoder: any;


  orderColorMapping: any = {
    issue: 'white',
    NA: 'black',
    pending: 'black',
    done: 'green'
  };
  orderBgColorMapping: any = {
    issue: 'red',
    NA: 'white',
    pending: 'white',
    done: 'lightgreen'
  };

  routeGeneralAction = [
    {
      titleDesc: 'dashboard.move_to_drop_point',
      actionType: 'moveToDropPoint'
    },
    {
      titleDesc: 'dashboard.add_one_more_order',
      actionType: 'addNewOrder'
    },
    // {
    //   titleDesc: 'dashboard.drop_at_drop_point',
    //   actionType: 'dropAtDropPoint'
    // },
    {
      titleDesc: 'dashboard.report_issue',
      actionType: 'reportIssue'
    },
  ];
  dropPointList: any;
  latitude: any;
  longitude: number;
  address: any;
  locationPermission: boolean;
  selectedDropPoint: any;
  userDoc: any;

  constructor(
    // private events: Events,
    private router: Router,
    private ngZone: NgZone,
    private toastController: ToastController,
    private platform: Platform,
    private authProvider: AuthProvider,
    private helperProvider: HelperProvider,
    private translationLoader: TranslationLoaderService,
    private location: Location,
    private alertController: AlertController
  ) { }

  ngOnInit() {

    this.platform.ready().then(() => {
      console.log('paltofm ', this.platform.platforms());
      this.isBrowser = (this.platform.platforms().includes('desktop') || this.platform.platforms().includes('mobileweb'));
      if (this.isBrowser) {
        this.initBrowser();
      } else {
        this.loadMapMobile();
      }
    });
    this.initLocationBrowser();
    this.userDoc = this.authProvider.getLocalUserData();
  }

  ionViewDidEnter() {

    let officeData: any = window.localStorage.getItem('ngStorage-selectedOffice');
    if (officeData) {
      officeData = JSON.parse(officeData);
    }

    if (!officeData) {
      // return this.router.navigateByUrl("/office-list");
      // this.getOfficeData();
    }

    this.initLogic();

    this.translationLoader.loadTranslations(english, polish);
    // this.getDashboardData();
    // this.getTiles();
    // this.loadWorkspaceList();
    // this.helperProvider.onEvent.subscribe((event) => {
    //   if (event !== 'user:officeChanged') {
    //     return;
    //   }
    //   this.getDashboardData();
    //   this.getTiles();
    // });
  }

  async initLogic() {
    try {
      await this.getMobileState();
      if (this.mobileState.routeId && this.mobileState.routeActive) {
        await this.getOrderList();
        await this.getRouteInfo();
        this.view = 'routeActive';
      } else if (this.mobileState.routeId) {
        await this.getRouteInfo();
        this.view = 'routeInfo';
      } else if (this.mobileState.carId) {
        await this.getAllGeminaRoutes();
        this.view = 'routeList';
      } else if (this.mobileState.companyId) {
        await this.getCarList();
        this.view = 'carList';
      } else {
        await this.getCompanyList();
        this.view = 'companyList';
        console.log('Moving to company selection');
      }
    } catch (error) {
      alert(error);
    }
  }


  async getRouteInfo() {
    this.routeData = await this.getMyData({ type: 'getOne', recId: this.mobileState.routeId, regId: ROUTE_ID });
    // this.loadMap();
  }
  async getCompanyList() {
    this.companyList = await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: COMPANY_ID, keys: ['loginEmail'] });
  }
  async getCarList() {
    this.carList = await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: CAR_LIST_ID, filter: { virtualOrgId: this.mobileState.virtualOrgId } });
  }
  async getOrderList() {
    this.orderList = await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: ORDER_ID, filter: { parentId: this.mobileState.routeId }, sort: { _id: 1 } });
    await this.getDropPointList();
  }
  async getDropPointList() {
    this.dropPointList = await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: CONTRACT_ID, filter: { virtualOrgId: this.mobileState.virtualOrgId, contractType: 'Zlewnia' } });
  }
  async getContractList() {
    return await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: CONTRACT_ID, filter: { virtualOrgId: this.mobileState.virtualOrgId, contractType: 'Firmy Asenizacyjne' } });
  }
  async getRouteList(orgName: string) {
    return await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: ROUTE_ID, filter: {
      // virtualOrgId: this.mobileState.virtualOrgId
      orgNameLocality: orgName,
      processStatusId: 2
    } });
  }

  async getAllGeminaRoutes() {
    const contracts = await this.getContractList();
    this.routeList = [];
    await Promise.all(contracts.map(async (ele) => {
      const routeList = await this.getRouteList(ele.virtualOrgName);
      this.routeList.push({
        orgName: ele.virtualOrgName,
        routes: routeList
      });
    }));
  }

  async getMobileState() {
    this.mobileState = await this.getMyData({ type: 'getMobileState' });
  }

  async setMobileState(obj: any) {
    this.mobileState = await this.getMyData({ type: 'setMobileState', state: obj });
  }

  async getMyData(data) {
    try {
      return await this.helperProvider.postRequest(`${environment.serverUrl}api/get-my-data`, data);
    } catch (error) {
      console.log("error in my data call", error);
      this.showAlert(error);
      return null;
    }
  }

  async getOfficeData() {
    // await this.helperProvider.getRequest(`${environment.serverUrl}api/get-my-data`, {  });
    // window.localStorage.setItem('ngStorage-selectedOffice');
  }

  async itemClicked(type: any, item: any) {
    const lastView = this.view;
    try {
      this.mobileState = this.mobileState || {};
      switch (type) {
        case 'company': {
          this.view = 'loading';
          this.mobileState.companyId = item._id;
          this.mobileState.orgName = item.orgName;
          this.mobileState.virtualOrgId = item.virtualOrgId;
          await this.setMobileState({ companyId: item._id, orgName: item.orgName, virtualOrgId: item.virtualOrgId });
          await this.getMyData({ type: 'actionClick', regId: COMPANY_ID, recId: item._id, actionType: 'companySelect' });
          await this.getCarList();
          this.view = 'carList';
        }
        break;
        case 'car': {
          this.view = 'loading';
          this.mobileState.carId = item._id;
          this.mobileState.carDesc = item.carDesc;
          this.mobileState.carPlates = item.carPlates;
          await this.setMobileState({ carId: item._id, carDesc: item.carDesc, carPlates: item.carPlates });
          await this.getMyData({ type: 'actionClick', regId: CAR_LIST_ID, recId: item._id, actionType: 'carSelect' });
          await this.getAllGeminaRoutes();
          this.view = 'routeList';
        }
        break;
        case 'route': {
          // const tempConfirm = await this.showAlert(`Are you sure you want to choose this route, Once Allocated you will not be able to change.`);
          // if (tempConfirm) {
            this.view = 'loading';
            this.mobileState.routeId = item._id;
            await this.setMobileState({ routeId: item._id });
            await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: item._id, actionType: 'routeInitSelect' });
            await this.getRouteInfo();
            this.view = 'routeInfo';
          // }
        }
        break;
        case 'route-remove': {
          // const tempConfirm = await this.showAlert(`Are you sure you want to choose this route, Once Allocated you will not be able to change.`);
          // if (tempConfirm) {
            this.view = 'loading';
            this.mobileState.routeId = item._id;
            await this.setMobileState({ routeId: null });
            await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: item._id, actionType: 'routeInitRemove' });
            await this.getAllGeminaRoutes();
            this.view = 'routeList';
          // }
        }
        break;
      }
    } catch (error) {
      this.view = lastView;
      this.showInfo(error);
      console.log('Error  = ', error);

    }
  }

  getMessage(type) {
    const lastView = this.view;

    try {
      let message;
      switch (type) {
        case 'company': {
          // message = 'Are you sure you want to change company?';
          message = 'Czy na pewno chcesz zmienić firmę?';
        }
        break;
        case 'car': {
          // message = 'Are you sure you want to change car?';
          message = 'Czy na pewno chcesz zmienić samochód?';
        }
        break;
      }
      return message;

    } catch (error) {
      this.view = lastView;
      this.showInfo(error);
      console.log('Error  = ', error);

    }
  }

  async changeItem(type: any) {
    const lastView = this.view;
    try {

          this.mobileState = this.mobileState || {};

          if (this.getMessage(type)) {
            const change = await this.showAlert(this.getMessage(type));
            if (!change) {
              return;
            }
          }


          switch (type) {
            case 'company': {
              this.view = 'loading';
              await this.getMyData({ type: 'actionClick', regId: COMPANY_ID, lastRecId: this.mobileState.companyId, actionType: 'companyRemove' });
              this.mobileState.companyId = null;
              this.mobileState.orgName = null;
              await this.setMobileState({ companyId: null, orgName: null });
              await this.getCompanyList();
              this.view = 'companyList';
              // this.view = 'carList';
            }
            break;
            case 'car': {
              this.view = 'loading';
              await this.getMyData({ type: 'actionClick', regId: CAR_LIST_ID, lastRecId: this.mobileState.carId, actionType: 'carRemove' });
              this.mobileState.carId = null;
              await this.setMobileState({ carId: null });
              await this.getCarList();
              this.view = 'carList';
            }
            break;
            case 'route': {
              this.view = 'loading';
              await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, lastRecId: this.mobileState.routeId, actionType: 'routeRemove' });
              this.mobileState.routeId = null;
              await this.setMobileState({ routeId: null });
              await this.getRouteInfo();
              this.view = 'routeList';
            }
            break;
            case 'generateRoute': {
              // const tempConfirm = await this.showAlert(`Are you sure you want to generate route, Once Allocated you will not be able to change.`);
              // if (tempConfirm) {
                this.view = 'loading';
                await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, carId: this.mobileState.carId, recId: this.mobileState.routeId, actionType: 'generateRoute' });
                await this.setMobileState({ routeActive: true });
                await this.getOrderList();
                await this.getRouteInfo();
                this.view = 'routeSuccess';
              // }
            }
            break;
          }

    } catch (error) {
      this.view = lastView;
      this.error = error;
      this.showInfo(error);
      console.log('Error  = ', error);
    }
  }

  openMap() {
    if (this.routeData.routeLink) {
      window.open(this.routeData.routeLink, '_blank');
    }
  }

  onModalOpen(item) {
    if (item.orderStatus === 'done' || item.orderStatus === 'close') {
      console.log("Cannot open = ", item.orderStatus);
      return null;
    }

    this.currentModalView = 'general';
    this.isModalOpen=true;
    this.selectedOrder = item;
    this.formData = {
      qtyTaken: null,
      tankEmpty: 'no',
      connector: item.connector || 'no'
    };
  }

  async sendAction(type: string) {

    const lastView = this.currentView;
    const lastView2 = this.currentModalView;
    this.currentView = 'loading';
    this.currentModalView = 'loading';
    await this.getMyData({ type: 'actionClick', regId: ORDER_ID, recId: this.selectedOrder._id, otherProblem: this.otherProblem, actionType: type });
    this.isToastOpen = true;
    this.toastMessage = `dashboard.action_success`;
    // this.showInfo('Action Success!');
    await this.closeOrderDetail();
    this.currentView = lastView;
    this.currentModalView = lastView2;
  }

  async sendRouteAction(type: string) {

    let lastView = this.currentView;
    try {
      this.currentView = 'loading';
      await this.setCurrentLocation();
      switch (type) {
        case 'addNewOrder':
          await this.setMobileState({ currentLocation: { lat: this.latitude, lng: this.longitude } });
          await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: this.mobileState.routeId, otherProblem: this.otherProblem, actionType: type });
          await this.getOrderList();
          lastView = 'pickup';
          break;
        case 'dropAtDropPoint':
          this.currentModalView = 'loading';
          await this.setMobileState({ currentLocation: { lat: this.latitude, lng: this.longitude } });
          await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: this.mobileState.routeId, otherProblem: this.otherProblem, actionType: type });
          // await this.getOrderList();
          this.isModalOpen = false;
          await this.initLogic();
          lastView = 'companyList';
          break;
          case 'moveToDropPoint':
            // await this.getDropPointList();
            if (this.dropPointList.length === 0) {
              return alert('No drop points defined');
            }
            if (this.dropPointList.length >= 2) {
              await this.getDropPoint();
            } else {
              this.selectedDropPoint = this.dropPointList[0]._id;
            }
            await this.setMobileState({ currentLocation: { lat: this.latitude, lng: this.longitude }, selectedDropPoint: this.selectedDropPoint });
          // dropPointList
          await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: this.mobileState.routeId, otherProblem: this.otherProblem, actionType: type });
          await this.getOrderList();
          lastView = 'pickup';
          break;
        default:
          await this.setMobileState({ currentLocation: { lat: this.latitude, lng: this.longitude } });
          await this.getMyData({ type: 'actionClick', regId: ROUTE_ID, recId: this.mobileState.routeId, otherProblem: this.otherProblem, actionType: type });
      }
  
      this.isToastOpen = true;
      this.toastMessage = `dashboard.action_success`;
      // this.showInfo('Action Success!');

    } catch (error) {
      console.log("Error  =", error);
      this.showInfo(error);
    }

    this.currentView = lastView;
  }


  async showInfo(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 1500,
      position: 'bottom',
    });

    await toast.present();
  }

  async loadMapMobile() {

    await CapacitorGoogleMaps.initialize({
      key: 'YOUR_IOS_MAPS_API_KEY',
      devicePixelRatio: window.devicePixelRatio, // this line is very important
    });

    const element = document.getElementById('map_canvas');

    const boundingRect = element.getBoundingClientRect();

    try {
      const result = await CapacitorGoogleMaps.createMap({
        cameraPosition: {},
        boundingRect: {
          width: Math.round(boundingRect.width),
          height: Math.round(boundingRect.height),
          x: Math.round(boundingRect.x),
          y: Math.round(boundingRect.y),
        },
      });

      // remove background, so map can be seen
      // (you can read more about this in the "Setting up the WebView" guide)
      element.style.background = '';

      // finally set `data-maps-id` attribute for delegating touch events
      element.setAttribute('data-maps-id', result.googleMap.mapId);

      alert('Map loaded successfully');
    } catch (e) {
      alert('Map failed to load');
    }
  }

  initLocationBrowser() {
    // this.geoCoder = new google.maps.Geocoder();
    this.setCurrentLocation()
    .then(() => {})
    .catch(() => {});
  }

  initBrowser() {
    // this.addMarker();
  }

  addMarker(marker: MapMarker) {
    // this.markerPositions.push(marker.getPosition() as google.maps.LatLngLiteral);
  }

  openMapByLink(type) {
    console.log('selectedOrder', this.selectedOrder);
    if (type === 'all') {
      this.openMap();
    } else {
      window.open(`https://www.google.com/maps/dir/Current+Location/${this.selectedOrder.location.coordinates[0]},${this.selectedOrder.location.coordinates[1]}`, '_blank');
    }
  }

  async closeOrderDetail() {
    this.view = 'loading';
    this.isModalOpen = false;
    await this.getOrderList();
    this.view = 'routeActive';
  }

  async completePickup() {
    if (!this.formData.qtyTaken) {
      // return this.showInfo('Quantity Taken is required');
      return this.showInfo('Wymagana jest ilość');
    }
    if (!this.formData.tankEmpty) {
      // return this.showInfo('Tank Empty is required');
      return this.showInfo('Wymagany jest czołg pusty');
    }
    if (!this.formData.connector) {
      // return this.showInfo('Connector is required');
      return this.showInfo('Złącze jest wymagane');
    }
    await this.getMyData({ type: 'actionClick', regId: ORDER_ID, recId: this.selectedOrder._id, otherProblem: this.otherProblem, actionType: 'completePickup', updateDoc: this.formData });
    this.toastMessage = `dashboard.action_success`;
    // this.showInfo('Action Success!');
    await this.closeOrderDetail();
  }

  async setCurrentLocation() {
    if ('geolocation' in navigator) {
      const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
      console.log('permissionStatus = ', permissionStatus);
      if (permissionStatus.state === 'granted') {
        this.locationPermission = true;
        console.log('Geolocation permission is granted');
        // You can now use navigator.geolocation.getCurrentPosition() safely
      } else if (permissionStatus.state === 'prompt') {
        // return alert('Geolocation permission is prompt (not granted or denied yet)');
        this.locationPermission = false;
      } else {
        // return alert('Geolocation permission is denied');
        this.locationPermission = false;
      }
      navigator.geolocation.getCurrentPosition((position) => {
        if (!this.latitude && !this.longitude) {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        }
        console.log('this.latitude = ', this.latitude, this.longitude);
        this.zoom = 18;
        // this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  getAddress(latitude: any, longitude: any) {
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results: any, status: any) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 18;
          this.address = results[0].formatted_address;
        } else {
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  async showAlert(message: any) {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertController.create({
        header: message,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              resolve(null);
            }
          },
          {
            text: 'OK',
            handler: (data) => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async getDropPoint() {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertController.create({
        header: 'Select Option',
        inputs: this.dropPointList.map((ele) => ({
            name: ele.signatura,
            type: 'radio',
            label: ele.signatura,
            value: ele._id
            // checked: true,
        })),
        // [
        //   {
        //     name: 'option1',
        //     type: 'radio',
        //     label: 'Option 1',
        //     value: 'option1',
        //     checked: true,
        //   },
        //   {
        //     name: 'option2',
        //     type: 'radio',
        //     label: 'Option 2',
        //     value: 'option2',
        //   },
        //   {
        //     name: 'option3',
        //     type: 'radio',
        //     label: 'Option 3',
        //     value: 'option3',
        //   },
        // ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              resolve(null);
            }
          },
          {
            text: 'OK',
            handler: (data) => {
              console.log('Selected Option:', data);
              this.selectedDropPoint = data;
              resolve(data);
              // You can use the selected value (data) here
            },
          },
        ],
      });

      await alert.present();
    });
  }

  reload() {
    window.location.reload();
  }

  logout() {
    this.authProvider.logout();
     // Navigate to the desired route
     this.router.navigate(['/login']);

     // Clear navigation history
     this.location.replaceState('/dashboard');
  }


  takeCar(item: any) {
    if (item.actualDriver) {

      if (this.userDoc && this.userDoc.email === item.actualDriver) {
        this.itemClicked('car', item);
      }
    } else {
      this.itemClicked('car', item)
    }
  }

}
